import { showLocalDate } from "../../../utilities/functions";

const EndDate = ({ row }) => {
  return <div>{row.endDate ? showLocalDate(row?.endDate) : ""}</div>;
};

export default EndDate;
